import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Challenge from './views/Challenge.vue'
import Results from './views/Results.vue'
import Leaderboard from './views/Leaderboard.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        section: 'home'
      },
      component: Home
    },
    {
      path: '/results',
      name: 'results',
      meta: {
        section: 'results'
      },
      component: Results
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      meta: {
        section: 'leaderboard'
      },
      component: Leaderboard
    },
    {
      path: '/challenge/:number',
      name: 'challenge',
      meta: {
        section: 'challenge'
      },
      component: Challenge,
      props: true
    },
    {
      path: '/challenge/:number/:view',
      name: 'challenge_view',
      meta: {
        section: 'challenge'
      },
      component: Challenge,
      props: true
    }
  ]
})

window.addEventListener('hashchange', function () {
  parent.postMessage('resize', '*')
})

export default router
